import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const ROWS = [
    { id: 'mock-1', title: 'Website redesign', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-2', title: 'Warehouse fit-out', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-3', title: 'CRM rollout', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
];

export const PMS_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/pms\/projects(\?|$)/i,
        handler: () => mockSuccess(listPayload(ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/pms\/projects\/([^/?]+)\/structure/i,
        handler: (req) => {
            const match = req.url.match(/\/projects\/([^/?]+)\/structure/i);
            const id = match ? match[1] : '';
            const row = ROWS.find((r) => r.id === id) ?? ROWS[0];
            return mockSuccess({
                ...row,
                sections: [
                    {
                        id: 'sec-1',
                        name: 'Phase 1',
                        section_cost: 12000,
                        items: [{ id: 'item-1', name: 'Design', estimated_cost: 12000 }],
                    },
                ],
                funding: {
                    total_cost: 12000,
                    funder_commitment: 10000,
                    earmarked: 5000,
                    missing_funds: 2000,
                    funding_gap: true,
                    currency: 'MUR',
                },
            });
        },
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/accounts\/projects\/([^/?]+)\/earmarks/i,
        handler: () => mockSuccess({ data: [{ id: 'e-1', amount: 5000, currency: 'MUR', notes: 'Mock earmark' }] }),
    },
];
